var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-videojs"},[_c('video',{staticClass:"video-js",attrs:{"id":"videoPlayer","crossOrigin":"anonymous","muted":""},domProps:{"muted":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }